import { render, staticRenderFns } from "./FeatureAll.vue?vue&type=template&id=4fb2d22c"
import script from "./FeatureAll.vue?vue&type=script&lang=js"
export * from "./FeatureAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports